import React from 'react';
import './index.css';
import { render } from 'react-dom';
import ReactPixel from 'react-facebook-pixel';
import { App } from './App';
ReactPixel.init('4247300422191389');
ReactPixel.pageView();
render(<App data-id="element-192" />, document.getElementById('root'));